import React from 'react';
import Heading from './Heading';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from 'react-icons/fa';
import { LiaChessBishopSolid } from "react-icons/lia";
import { IoIosStarOutline} from "react-icons/io";
import { IoClipboardOutline,IoSearchOutline } from "react-icons/io5";
import { PiUserCircleGearLight } from "react-icons/pi";
import { Helmet } from 'react-helmet';

const CultureNexify = ({ title }) => {

  const isBusinessSolution = title === "Consultant Career";
  const isconsultant = title === "Consulting with Nexify Clients";


  return (
    <div className="w-full max-w-[1320px] px-4 mx-auto mt-20 mb-5">
       <Helmet>
        <title>Culture - Nexify Infosystems</title>
        <meta name="description" content="Learn about Nexify's core values, what we look for in employees, and how we foster a supportive and inclusive culture." />
        <meta name="keywords" content="Nexify, Careers, Culture, Employee Experience, Opportunities, Business Solutions, Community Involvement, Mentorship" />
      </Helmet>
      <Heading
        maintitle="Nexify Careers"
        title={
          <>
            <span>Nexify</span>
            <span className={isBusinessSolution ? "text-red-500" : "text-black"}> Culture</span>
          </>
        }
      />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-10">
        {/* First Product Icon */}
        <div className="bg-white  shadow-md p-6 flex flex-col items-center justify-between text-center">
         <div className="flex items-center justify-center w-16 h-16 text-[#005eb8] bg-[#c9e1f7] mb-2 rounded-sm">
                     <IoIosStarOutline  className="text-4xl" />
                   </div>
            <h2 className="font-[500] text-lg">Heart of Nexify</h2>
            <p className="text-gray-600 mt-2 text-[13px]">
            Nexify's core values are its people, who are united through an open-door policy, unique training programs, mentorships, and Employee Resource Groups, fostering a supportive and inclusive environment.
            </p>
        </div>

        {/* Second Product Icon */}
        <div className="bg-white  shadow-md p-6 flex flex-col items-center justify-between text-center">
        <div className="flex items-center justify-center w-16 h-16 text-[#f5bd00] bg-[#f6e9be] mb-2 rounded-sm">
                    <IoClipboardOutline className="text-4xl" />
                  </div>
            <h2 className="font-[500] text-lg">Creating Opportunity</h2>
            <p className="text-gray-600 text-[13px]">
            Nexify fosters a performance-driven culture by hiring top talent, training them, and allowing them to lead the company. They welcome authenticity and openness, promoting professionalism and respect for all employees.
            </p>
        </div>

        {/* Third Product Icon */}
        <div className="bg-white  shadow-md p-6 flex flex-col items-center justify-between text-center">
        <div className="flex items-center justify-center w-16 h-16 text-[#d23290] bg-[#f4c6e1] mb-2 rounded-sm">
                    <IoSearchOutline  className="text-4xl" />
                  </div>
            <h2 className="font-[500] text-lg">What We Look For</h2>
            <p className="text-gray-600 text-[13px]">
            We look for individuals with a competitive nature, ambition, and drive, as well as self-starters who have strong communication and leadership skills. We also value individuals who are adaptable, resilient, and able to thrive in dynamic, fast-paced environments.
            </p>
        </div>

        {/* Fourth Product Icon - Improve Employee Experience */}
        <div className="bg-white  shadow-md p-6 flex flex-col items-center justify-between text-center">
        <div className="flex items-center justify-center w-16 h-16 text-[#4f2929] bg-[#ead3d3] mb-2 rounded-sm">
                    <LiaChessBishopSolid className="text-4xl" />
                  </div>
          <div className="flex flex-col">
            <h2 className="font-[500] text-lg">How We Can Help</h2>
            <p className="text-gray-600 text-[13px]">
            Nexify offers on-the-job training and performance-based promotion, allowing entry-level recruiters to quickly advance and create their own opportunities for earning and advancement.
            </p>
          </div>
        </div>

        {/* Fifth Product Icon - Enhance Customer Experience */}
        <div className="bg-white  shadow-md p-6 flex flex-col items-center justify-between text-center">
         <div className="flex items-center justify-center w-16 h-16  text-[#5dd73f] bg-[#d7fbce] mb-2 rounded-sm">
                    <PiUserCircleGearLight  className="text-4xl" />
                  </div>
          <div className="flex flex-col">
            <h2 className="font-[500] text-lg">Nexify Gives Back </h2>
            <p className="text-gray-600 text-[13px]">
            Nexify values community involvement, donating to worthy causes and encouraging employees to volunteer for local charities. They even provide paid leave for volunteering.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white flex flex-col md:flex-row lg:p-12 p-6 w-full max-w-[1320px] lg:text-center md:shadow-lg md:rounded-lg gap-20 lg:mb-10 lg:mt-10 justify-center items-center">
        {/* Left Side */}
        <div className="lg:mb-2 md:mb-0 lg:text-center">
          <h3 className="lg:text-3xl text-xl font-[500] text-black mt-2">Follow us for updates at #NexifyCareers</h3>
        </div>

        {/* Social Media Icons */}
        <div className="flex lg:justify-center lg:items-center lg:gap-6 gap-3 lg:mt-4 mt-[-40px] md:mt-0 ">
         
          <a
           href="https://www.linkedin.com/company/nexify-infosystems-llc" 
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center w-14 h-14 rounded-md bg-[#005eb8] text-white text-2xl"
          >
            <FaLinkedinIn />
          </a>
          <a
                   href="https://www.instagram.com/nexify_infosystems?igsh=MXZkN3loYWtiYmVpdw==" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center w-14 h-14 rounded-md bg-[#005eb8] text-white text-2xl"
                  >
                    <FaInstagram />
                  </a>
        </div>
      </div>
    </div>
  );
};

export default CultureNexify;
